// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__33o9Y","itemA":"Write_itemA__2yt9t","itemB":"Write_itemB__1KTHv","itemC":"Write_itemC__2miBx","itemD":"Write_itemD__3YAP-"};